__turbopack_context__.v({
  "card": "_18Cv1q_card",
  "grid": "_18Cv1q_grid",
  "image-wrap": "_18Cv1q_image-wrap",
  "price": "_18Cv1q_price",
  "sub": "_18Cv1q_sub",
  "tag": "_18Cv1q_tag",
  "title": "_18Cv1q_title",
});
